import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Stack,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  OFFER_STATUS_COLOR,
  pill,
  formatDate,
  locationsToText,
  arrayToText,
  tableHeadCellSx,
  tableBodyCellSx,
} from "bundles/Internal/components/CompanyShowPage";

function CompanyJobOffersTab({ jobOffers, loading }) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <Stack spacing={1} sx={{ p: 4 }}>
        {[...Array(5)].map((_, i) => (
          <Skeleton key={i} variant="rectangular" height={36} />
        ))}
      </Stack>
    );
  }
  if (!jobOffers || jobOffers.length === 0) {
    return (
      <Box sx={{ p: 8, textAlign: "center" }}>
        <Typography sx={{ color: "hsl(150 10% 46%)", fontSize: 14 }}>
          No job offers for this company.
        </Typography>
      </Box>
    );
  }
  return (
    <Box sx={{ overflowX: "auto" }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {[
              "Id",
              "Job title",
              "Status",
              "Categories",
              "End of mandate",
              "Applications",
              "Views",
              "Intent to apply",
              "Locations",
              "Created",
              "Job statuses",
              "Language",
              "Recruiter",
            ].map((label) => (
              <TableCell key={label} sx={tableHeadCellSx}>{label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {jobOffers.map((offer) => {
            const statusColor = OFFER_STATUS_COLOR[offer.offer_status] || OFFER_STATUS_COLOR.closed;
            return (
              <TableRow
                key={offer.id}
                hover
                onClick={() => navigate(`/internal/job_offers/${offer.id}`)}
                sx={{
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "hsl(140 8% 90%)" },
                  "&:last-child td": { borderBottom: "none" },
                }}
              >
                <TableCell sx={tableBodyCellSx}>{offer.id}</TableCell>
                <TableCell sx={tableBodyCellSx}>{offer.job_title || "—"}</TableCell>
                <TableCell sx={tableBodyCellSx}>
                  {offer.offer_status ? pill(offer.offer_status, statusColor) : "—"}
                </TableCell>
                <TableCell sx={tableBodyCellSx}>{arrayToText(offer.categories)}</TableCell>
                <TableCell sx={tableBodyCellSx}>{formatDate(offer.end_of_mandate) || "—"}</TableCell>
                <TableCell sx={tableBodyCellSx}>{offer.job_applications_count ?? 0}</TableCell>
                <TableCell sx={tableBodyCellSx}>{offer.view_count ?? 0}</TableCell>
                <TableCell sx={tableBodyCellSx}>{offer.intent_apply_count ?? 0}</TableCell>
                <TableCell sx={tableBodyCellSx}>{locationsToText(offer.locations)}</TableCell>
                <TableCell sx={tableBodyCellSx}>{formatDate(offer.created_at) || "—"}</TableCell>
                <TableCell sx={tableBodyCellSx}>{arrayToText(offer.job_statuses)}</TableCell>
                <TableCell sx={tableBodyCellSx}>{offer.offer_language || "—"}</TableCell>
                <TableCell sx={tableBodyCellSx}>
                  {offer.recruiter
                    ? offer.recruiter.full_name || offer.recruiter.email
                    : "—"}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Box>
  );
}

export default CompanyJobOffersTab;
